import axios from 'axios'
import {handleRequestErrors} from "@/js/functions/handleRequestErrors.ts";
import {toast} from "vue3-toastify";
import {errorMsg} from "@/i18n/i18nCommon.tsx";

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    withCredentials: true, // Gửi kèm HttpOnly cookies
    timeout: 90000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

// Interceptor cho request
api.interceptors.request.use(
    config => {
        // Thêm thông tin trình duyệt và thiết bị
        config.headers['X-Client-Version'] = import.meta.env.VITE_APP_VERSION || '1.0.0'
        config.headers['X-Client-Platform'] = 'web'

        return config
    },
    error => {
        console.error('API request error:', error)
        return Promise.reject(error)
    }
)

// Interceptor cho response
api.interceptors.response.use(
    response => {
        return response
    },
    error => {
        // Xử lý lỗi
        if (error.response) {
            const errors = handleRequestErrors(error.response)

            // Lỗi từ phản hồi server (status code không phải 2xx)
            // console.error(`API Error ${error.response.status}:`, error.response.data)

            // Lưu lỗi vào localStorage để debug (thay cho Sentry)
            if (error.response.status >= 500) {
                try {
                    const errors = JSON.parse(localStorage.getItem('api_errors') || '[]')
                    errors.push({
                        time: new Date().toISOString(),
                        status: error.response.status,
                        data: error.response.data,
                        url: error.response.config.url
                    })
                    // Giữ tối đa 20 lỗi gần nhất
                    if (errors.length > 20) errors.shift()
                    localStorage.setItem('api_errors', JSON.stringify(errors))
                } catch (e) {
                    console.error('Error logging to localStorage', e)
                }
            }

            if (errors) {
                return Promise.reject(errors)
            }
        } else if (error.request) {
            toast.error(errorMsg.Error);

            // Lỗi không có phản hồi từ server
            console.error('API Error (No response):', error.request)

            // Lưu lỗi kết nối vào localStorage
            try {
                const errors = JSON.parse(localStorage.getItem('network_errors') || '[]')
                errors.push({
                    time: new Date().toISOString(),
                    message: 'No response from server',
                    url: error.config.url
                })
                // Giữ tối đa 20 lỗi gần nhất
                if (errors.length > 20) errors.shift()
                localStorage.setItem('network_errors', JSON.stringify(errors))
            } catch (e) {
                console.error('Error logging to localStorage', e)
            }
        } else {
            toast.error(errorMsg.Error);

            // Lỗi khi thiết lập request
            console.error('API Error (Setup):', error.message)
        }

        // return Promise.reject(error)
    }
)

export default api